import qs from 'qs';
import {
  JW_PLAYER_AD_TAG_PARAMS,
  JW_PLAYER_AD_UNIT_PATHS
} from 'constants/video';
import { toSlug } from 'util/string';

export const JW_HIDE_ADS_TAG = 'hide-ads';

// Returns a video's tags as an array of lowercase values
export const getTags = video =>
  (video.tags ? video.tags.split(',') : []).map(toSlug);

export const getCustParams = (placement, post) => {
  const postTargetingParams = post && post.ads ? post.ads.targeting : {};
  // Convert post targeting to an object of keys with comma separated values,
  // e.g. { <key>: '<value>,<value>,<value>' }
  const postTargetingValues = Object.entries(postTargetingParams).reduce(
    (p, [key, value]) => {
      if (Array.isArray(value) && value.length) {
        return { ...p, ...{ [key]: value.join(',') } };
      }
      return p;
    },
    {}
  );

  return {
    video_zone_id: placement,
    media_id: '__item-mediaid__',
    // Slugify JW tags
    jw_tags: '__item-tags__',
    // Add post id if it is available
    ...(post ? { post_id: post.resourceId } : {}),
    // Add post targeting values if they are set
    ...postTargetingValues
  };
};

// Get the ad tag for a video
export const getAdTag = (placement, post) => {
  const params = Object.assign(
    {},
    {
      // Ad unit path
      iu: JW_PLAYER_AD_UNIT_PATHS[placement] || JW_PLAYER_AD_UNIT_PATHS.default
    },
    JW_PLAYER_AD_TAG_PARAMS,
    {
      // Add custom params, see https://support.google.com/dfp_premium/answer/1080597
      // for details
      cust_params: qs.stringify(getCustParams(placement, post), {
        encode: false
      })
    }
  );

  // Build the complete tag
  return `https://pubads.g.doubleclick.net/gampad/ads?${qs.stringify(params)}`;
};
